<template>
    <div>
        <div class="xueshi">
            <div class="chha">
                <div class="zziiz">学时管理</div>
            </div>
        </div>
        <div class="yanzheng">
            <div class="marjor">
                <div v-for="(item,index) in marjorList" :key="item" @click="marClk(index,item)" :class="curIndex === index?'activeMarjorItem':''" class="marjorItem">{{item.majorName}}</div>
            </div>
            
            <div class="xiangmu">
                <div v-if="majorKeyWord == 1 || majorKeyWord == 2 || majorKeyWord == 4">
                    <!-- <Form  :label-width="80" :inline="true" class-name="form-box">
                        <FormItem  label="年度">
                            <Select v-model="yearsModel" @change="dateChange()" placeholder="请选择年度" style="width:150px">
                                <Option v-for="item in years" :value="item.value" :label="item.label" :key="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                        <div class="tips">勾选多个年份可以合并打印</div>
                        <div class="btn-box">
                            <Button type="primary" class="hhh" @click="hebing()">合并打印</Button >
                            <Button type="primary" class="hhh" @click="queryPeriod()">查询</Button >
                            <Button type="primary" class="ttt" @click="reset()">重置</Button>
                        </div>
                    </Form> -->
                    <div class="btnBoxs">
                        <Button type="primary" class="hhh" @click="hebing()">合并打印</Button >
                    </div>
                    <div class="tableHeader">
                        <div>全选</div>
                    </div>
                    <Table
                        border
                        ref="selection"
                        @on-select-all="Checkedall"
                        @on-select-all-cancel="Checkedcancel"
                        @on-select-cancel="Checked"
                        @on-select="OnChecked"
                        :columns="columns4"
                        :data="data1"
                        max-height="892">
                            <template slot-scope="{ row }" slot="name">
                                <strong>{{ formatDate(row.updateTime) }}</strong>
                            </template>
                    </Table>
                </div>
                <div v-else>
                    <h2 style="margin-bottom: 15px">浙江药师网</h2>
                    <Table border :columns="columns5" :data="periodLists">
                        <template slot="credit" slot-scope="{row}">
                            <div class="importStatus" >{{row.abutmentStatus | statusImport}}</div>
                        </template>
                        <template slot="action" slot-scope="{row}">
                            <span v-if="row.abutmentStatus > 0" class="details" @click="clkDetails(row,1)">导入详情</span>
                        </template>
                    </Table>
                    <div class="gray">备注：1、完成学习、考试、调查问卷后，次日起可前往浙江药师网查询学时。查询网址：<a href="http://www.zjda.com/credit/search.shtml" class="details">http://www.zjda.com/credit/search.shtml</a></div>
                    <div class="gray">2、仅显示2023年5月1日与浙江药师网学分对接后结果！</div>
                    <div class="gray">3、如果导入失败，请根据反馈原因和浙江药师网信息登记情况进行修正后与服务中心联系：0571-88903229</div>
                    <div v-if="majorKeyWord == 12">
                        <h2 style="margin-bottom: 15px;margin-top: 25px">浙江省专业技术人员继续教育学时登记管理系统</h2>
                        <Table border :columns="columns5" :data="periodLists">
                            <template slot="credit" slot-scope="{row}">
                            <div class="importStatus" >{{row.abutmentStatus | statusImport}}</div>
                        </template>
                        <template slot="action" slot-scope="{row}">
                            <span v-if="row.abutmentStatus > 0" class="details" @click="clkDetails(row,1)">导入详情</span>
                        </template>
                        </Table>
                        <div class="gray">备注：1、成功完成培训24小时后可前往浙江省专业技术人员继续教育学习平台查询，网址：<a href="https://zjjx.rlsbt.zj.gov.cn/" class="details">https://zjjx.rlsbt.zj.gov.cn/</a></div>
                        <div class="gray">2、仅显示2023年3月1日与浙江省专业技术人员继续教育学时登记管理系统对接后结果</div>
                        <div class="gray">3、如果导入失败，请查看反馈原因，如有疑问请与服务中心联系：：0571-88903229</div>
                    </div>
                </div>
                <div id="fangzhi" style="display: none"></div>
            </div>
        </div>
        <el-dialog title="导入结果" :visible.sync="failShow" width="30%">
            <el-form label-position="left" label-width="80px">
                <el-form-item label="年度">
                    {{rowData.trainTime}}
                </el-form-item>
                <el-form-item label="专业">
                    {{rowData.majorName}}
                </el-form-item>
                <el-form-item label="导入学时">
                    {{rowData.finishedPeriod}}
                </el-form-item>
                <el-form-item label="导入时间">
                    {{rowData.peopleOfficeTime}}
                </el-form-item>
                <el-form-item label="导入系统">
                    {{rowData.operType | typeImport}}
                </el-form-item>
                <el-form-item label="导入状态">
                    {{rowData.peopleOfficeStatus | statusImport}}
                </el-form-item>
                <el-form-item label="失败原因">
                    <span v-if="rowData.operType == 2">{{rowData.peopleOfficeFailReson}}</span>
                    <span v-else>{{rowData.abutmentFailReson}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="failShow = false">取 消</el-button>
                <el-button type="primary" @click="failShow = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
    </template>
    <script>
    import {queryPeriod, periodExport ,getSelectMajor} from "network/LPersonal";
    import {queryAllMajor} from 'network/home.js'
    import { formatDate } from "common/utils";
    import Cookies from "js-cookie";
    import expandRow from './table-expand.vue';
    export default {
        components: { expandRow },
        data() {
            let that = this;
            return {
                flag: false,
                failShow: false,
                rowData: {},
                typexue: "",
                yearsModel: "",
                years: [],
                yeararr: [],
                curIndex: 0,
                marjorList: ['执业药师','药学初级','食品质量技术','医药工程师','医疗器械'],
                sex: "",
    
                message: {},
                modal2: false,
                shenid: "",
                value3: "",
                majorKeyWord: "",
                year: "",
                certificatesLevel: [],
                data2: {
                    user: {}
                },
                fenlei: "",
                modal1: false,
                columns4: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center",
                    },
                    {
                            title: '年度',
                            key: 'trainTime',
                            align: "center",
                        },
                        {
                            title: '专业',
                            key: 'majorName',
                            align: 'center'
                        },
                        
                        {
                            title: '学时',
                            align: "center",
                            key: 'period'
                        },
                        {
                            title: '学分',
                            align: "center",
                            key: 'credit'
                        },
                        {
                            type: 'expand',
                            width: 90,
                            render: (h, params) => {
                                return h(expandRow, {
                                    props: {
                                        periodList: params.row.periodList,
                                        type: that.majorKeyWord
                                    }
                                })
                            }
                        },
                    {
                        title: "操作",
                        key: "dayin",
                        align: "left",
                        width: 90,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {
                                        style: {
                                            color: "#4771ea",
                                        },
                                        on: {
                                            click: () => {
                                                let idCard = this.Get("username")
                                                let year = []
                                                year.push(params.row.trainTime)
                                                periodExport({
                                                    idCard:idCard,
                                                    majorId:this.majorKeyWord,
                                                    years:year
                                                }).then(res=>{
                                                    console.log(res);
                                                    if(res.status==200){
                                                        this.data3=res.data.data
                                                        console.log(this.data3,"数据");
                                                        this.$router.push({
                                                            name:"Preview",
                                                            params:{
                                                                row:this.data3
                                                            }
                                                        })
                                                    }
                                                            
                                                })
                                                
                                            },
                                        },
                                    },
                                    (params.row.dayin = "打印")
                                ),
                            ]);
                        },
                    },
                ],
                columns5: [
                        {
                            title: '项目',
                            key: 'projectName',
                            align: "center",
                        },
                        {
                            title: '年度',
                            key: 'year',
                            align: "center",
                        },
                        // {
                        //     title: '科目分类',
                        //     align: "center",
                        //     render(h, params) {
                        //         if (params.row.subjectType == 1) {
                        //             return h(
                        //                 "span", {
                        //                     style: {
                        //                         color: "#888",
                        //                     },
                        //                 },
                        //                 "一类专业学时"
                        //             );
                        //         }else if (params.row.subjectType == 2) {
                        //             return h(
                        //                 "span", {
                        //                     style: {
                        //                         color: "#3562E8",
                        //                     },
                        //                 },
                        //                 "二类专业学时"
                        //             );
                        //         }
                        //     },
                        // },
                        {
                            title: '学时',
                            align: "center",
                            key: 'finishedPeriod',
                        },
                        {
                            title: '学分',
                            align: "center",
                            key: 'credit'
                        },
                        {
                            title: '学时(学分)导入结果',
                            align: "center",
                            key: 'credit',
                            minWidth: 120, 
                            slot: 'credit'
                        },
                        {
                            title: '操作',
                            align: "center",
                            key: 'credit',
                            minWidth: 120, 
                            slot: 'action'
                        }
                ],
                data1: [],
                data3: "",
                printList: [],
                periodLists: [],
            };
        },
        created() {
            this.getSelectMajor()
            this.queryAllMajor();
            this.time();
            this.$emit("editPage", "学时管理", "学时查询");
        },
        activated(){
            this.$emit("editPage", "学时管理", "学时查询");
        },
        filters: {
        },
        methods: {
            clkDetails(data,type) {
                this.rowData = JSON.parse(JSON.stringify(data));
                this.rowData.operType = type;
                this.failShow = true;
            },
            marClk(index,item) {
                this.curIndex = index;
                this.majorKeyWord = item.id;
                if(item.id == 3) {
                    this.seachCredit(item.id);
                    return
                }
                if(item.id == 12) {
                    this.seachCredit(item.id);
                    return
                }
                this.queryPeriod();
            },
            seachCredit(id) {
                queryPeriod({
                    userId: this.Get("userId"),
                    majorId:id,
                    curPage:1,
                    maxPage:10,
                }).then(res=>{
                    console.log(res);
                    if(res.status==200){
                        this.periodLists=res.data.data
                    }
                            
                })
            },
            queryAllMajor() {
                queryAllMajor()
                .then(res => {
                    console.log(res,'queryAllMajor');
                    if(res.data.code == 200) {
                        this.marjorList = [];
                        let obj = {};
                        res.data.data.forEach(e => {
                            if(e.id === 3) {
                                obj = e;
                                return
                            }
                            this.marjorList.unshift(e);
                        })
                        this.marjorList.unshift(obj);
                        this.majorKeyWord = obj.id;
                        this.seachCredit(obj.id);
                        console.error( this.majorKeyWord);
                    }
                })
            },
    
            reset(){
                this.yeararr = []
                this.data1 = []
                this.yearsModel = ""
            },
            getSelectMajor(){
                getSelectMajor().then(res=>{
                    console.log(res,"专业类别");
                    this.certificatesLevel = res.data.data
                    this.certificatesLevel.forEach((item,i)=>{
                    if(item.majorName=="执业药师"||item.majorName=="药学初级"){
                        this.certificatesLevel.splice(i,1)
                    }
                    })
                })
            },
            mockTableData1 () {
                    let data = [];
                    for (let i = 0; i < 10; i++) {
                        data.push({
                            name: 'Business' + Math.floor(Math.random () * 100 + 1),
                            status: Math.floor(Math.random () * 3 + 1),
                            portrayal: ['City', 'People', 'Cost', 'Life', 'Entertainment'],
                            people: [
                                {
                                    n: 'People' + Math.floor(Math.random () * 100 + 1),
                                    c: Math.floor(Math.random () * 1000000 + 100000)
                                },
                                {
                                    n: 'People' + Math.floor(Math.random () * 100 + 1),
                                    c: Math.floor(Math.random () * 1000000 + 100000)
                                },
                                {
                                    n: 'People' + Math.floor(Math.random () * 100 + 1),
                                    c: Math.floor(Math.random () * 1000000 + 100000)
                                }
                            ],
                            time: Math.floor(Math.random () * 7 + 1),
                            update: new Date()
                        })
                    }
                    return data;
                },
                formatDate (date) {
                    const y = date.getFullYear();
                    let m = date.getMonth() + 1;
                    m = m < 10 ? '0' + m : m;
                    let d = date.getDate();
                    d = d < 10 ? ('0' + d) : d;
                    return y + '-' + m + '-' + d;
                },
                changePage () {
                    // The simulated data is changed directly here, and the  uactualsage scenario should fetch the data from the server
                    this.tableData1 = this.mockTableData1();
                },
            dateChange() {
                    // console.log(this.yearsModel);
                    var myDate = new Date();
                    var year = myDate.getFullYear(); //获取当前年
                    // if (this.yearsModel == year) {
                    //     this.flag = false;
                    // } else {
                    //     this.flag = true;
                    // }
                },
            time() {
                    var myDate = new Date();
                    var year = myDate.getFullYear(); //获取当前年
                    this.initSelectYear(year);
                },
            initSelectYear(year) {
                    this.years = [];
                    for (let i = 0; i < 20; i++) {
                        this.years.push({
                            value: year - i,
                            label: year - i + "年"
                        });
                    }
                },
            toadd(){},
            hebing() {
                console.log(this.yeararr);
                if(this.yeararr.length < 1){
                    this.$Message.info('请先选择学时后操作');
                    return
                }
                let idCard = this.Get("username")
                periodExport({
                    idCard:idCard,
                    majorId:this.majorKeyWord,
                    years:this.yeararr
                }).then(res=>{
                    console.log(res);
                    if(res.status==200){
                        this.data3=res.data.data
                        console.log(this.data3);
                        this.$router.push({
                            name:"Preview",
                            params:{row:this.data3}
                        })
                    }
                            
                })
                
            },
            Checkedcancel(e,i) {
                this.yeararr = []
            },
            Checkedall(e,i) {
                this.yeararr = []
                e.forEach((item,index)=>{
                    this.yeararr.push(item.trainTime)
                })
            },
            OnChecked(e,i) {
                this.yeararr.push(i.trainTime)
            },
            Checked(e,i) {
                console.log(e,i);
                this.yeararr.forEach((item,index)=>{
                    if(i.trainTime==item){
                        this.yeararr.splice(index,1)
                    }
                })
            },
            tonewc() {
                this.modal1 = false;
                this.$router.push("/certificate1");
            },
            
            handleSelectAll(status) {
                this.$refs.selection.selectAll(status);
            },
    
            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            sortFun(attr,rev){
                        //第二个参数没有传递 默认升序排列
                        if(rev ==  undefined){
                            rev = 1;
                        }else{
                            rev = (rev) ? 1 : -1;
                        }
                        
                        return function(a,b){
                            a = a[attr];
                            b = b[attr];
                            if(a < b){
                                return rev * -1;
                            }
                            if(a > b){
                                return rev * 1;
                            }
                            return 0;
                        }
                    },
           queryPeriod(){
               if(this.majorKeyWord ==""||this.majorKeyWord==null||this.majorKeyWord==undefined){
                   this.$Message.info("请选择专业")
               } else{
                   this.yeararr= []
                   let id = this.Get("userId")
                    queryPeriod({
                    curPage:1,
                    maxPage:1000,
                    userId:id,
                    //    userId:this.Get("userId"),
                    year:this.yearsModel,
                    majorId:this.majorKeyWord
                    }).then(res=>{
                        console.log(res,"学时查询");
                        this.data1 = res.data.data
                        this.data1=this.data1.sort(this.sortFun(`trainTime`,1));
                        this.data1 = this.data1.reverse()
                        if(this.data1.length<1){
                            this.$Message.error({
                                content:"暂无完成学时",
                                duration:5
                            })
                        }
                    })
               }
           }
        },
        filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, 'yyyy.MM.dd'); 
        },
       typeImport(val) {
                if(val === 2) {
                    return '浙江省专业技术人员继续教育学时登记管理系统';
                }
                else {
                    return '浙江药师网';
                }
            },
            statusImport(val) {
                if(!val) {
                    return '暂无同步'
                }
                if(val === 1) {
                    return '导入失败'
                }
                if(val === 2) {
                    return '导入成功'
                }
            },
        
      }
        
    };
    </script>
    <style lang="less" scoped>
    .form-box{
        display: flex;
        justify-content: space-between;
    }
    .zziiz {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4771EA;
        margin-left: 30px;
        padding-top: 20px;
    }
    .yanzheng {
        width: 900px;
        padding-left: 30px;
        margin-top: 36px;
    }
    
    .xueshi {
        width: 800px;
        margin-top: 20px;
        font-size: 14px;
        /* margin-left: 25px; */
        display: flex;
        justify-content: space-between;
    }
    .shu1 {
        width: 250px;
        margin-left: 10px;
    }
    .shu2 {
        width: 250px;
        margin-left: 6px;
    }
    .btq {
        width: 100px;
    }
    .xiangmu {
        width: 895px;
        margin-top: 50px;
        margin-left: -52px;
    }
    /deep/.test-name {
        background-color: #f7faff;
        border: none;
    }
    /deep/ .ivu-table-header thead tr th {
        background-color: #f7faff;
        font-weight: bold;
        font-size: 16px;
        color: #333;
        border: none;
    }
    /deep/.ivu-table-row {
        background-color: #f7faff;
        font-size: 16px;
        color: #676767;
        border: none;
    }
    
    /deep/ .ivu-table-wrapper-with-border {
        border: none;
    }
    /deep/ .ivu-table-header {
        border: none;
    }
    /deep/ .ivu-table-border {
        border: none !important;
    }
    
    .hhh {
        height: 40px;
        background: #3562e8;
        margin-left: 20px;
    
    }
    .ttt {
        height: 40px;
        background: #3562e8;
        margin-left: 10px;
    }
    .ninn {
        text-align: center;
        margin-top: 50px;
        font-size: 24px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #333333;
    }
    .shifou {
        margin-top: 100px;
        margin-bottom: 100px;
        font-size: 26px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #3562e8;
    }
    .buuu {
        background: #3562e8;
        border-radius: 4px;
        color: #ffffff;
    }
    
    .xingming {
        display: inline-block;
        width: 250px;
    }
    .shfenz {
        display: inline-block;
        width: 300px;
    }
    .xingb {
        display: inline-block;
        width: 150px;
        
    }
    .zhenss {
        padding-top: 20px;
        border-bottom: 1px solid #bfbfbf;
        padding-bottom: 20px;
    }
    .nianfenn {
        padding-top: 20px;
        border-bottom: 1px solid rgba(191, 191, 191, 0.2);
        padding-bottom: 20px;
    }
    .zxn {
        display: inline-block;
        width: 250px;
        color: blue;
    }
    .fennw {
        display: inline-block;
        width: 250px;
        color: blue;
    }
    .leixix {
        padding-top: 20px;
        border-bottom: 1px solid #bfbfbf;
        padding-bottom: 20px;
    }
    .leixixi {
        display: inline-block;
        width: 250px;
    }
    .chha{
        width: 800px;
        display: flex;
        justify-content: space-between;
    }
    .xianmu{
        width: 300px;
        display: flex;
        justify-content: space-around;
    
    }
    .niandu{
        width: 300px;
        display: flex;
        justify-content:space-around;
        margin-left: 10px;
    }
    .mmu{
        width: 40px;
        margin-top: 10px;
      
    }
    .du{
         width: 40px;
          margin-top: 10px;
    }
    #print-iframe{
        width: 1px;
        height: 1px;
        overflow: hidden;
        opacity: 0;
    }
    .schoolQuery, .creditInquiry{
        font-size: 16px;
        margin-top: 30px;
    }
    /deep/ .ivu-form{
        display: flex;
        justify-content: space-between;
    }
    
    .marjor {
        display: flex;
        align-items: center;
        .marjorItem {
            width: 140px;
            height: 50px;
            line-height: 50px;
            background-color:#3562e8;
            color: #fff;
            font-size: 20px;
            text-align: center;
            margin-right: 5px;
            border-radius: 10px;
            cursor: pointer;
        }
        
        .activeMarjorItem {
            border: 1px solid #3562e8;
            background-color: #fff;
            color: #3562e8;
        }
    }
    .importStatus {
        margin-right: 10px;
        display: inline-block;
    }
    .details {
        color: #3562e8;
    }
    .gray {
        color: #666;
    }
    /deep/.ivu-checkbox-inner{
        border: 1px solid #666;
    }
    .tips {
        font-size: 16px;
        margin-top: 5px;
        text-align: right;
    }
    .tableHeader {
        position: relative;
        top: 31px;
        z-index: 999;
        right: -47px;
        font-size: 14px;
        font-weight: bold;
    }
    /deep/.ivu-table-cell-expand{
     -webkit-transform: rotate(0deg);
     transform: rotate(0deg);
    }
    /*2.展开按钮未点击的样式是加号带边框*/
   /deep/.ivu-table-cell-expand .ivu-icon-ios-arrow-forward:before {
    content: "详情";
    color: rgb(71, 113, 234);
    font-size: 16px;
  }
    /*3.展开按未点击的样式是减号带边框*/
    /deep/.ivu-table-cell-expand-expanded .ivu-icon-ios-arrow-forward:before{
        content: "详情";
    }
    .btnBoxs {
        text-align: right;
    }
    </style>